var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "pb-2 font-weight-bold text-uppercase" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.__("plan.form.paragraph.included")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.plan_features, function (plan_feature, index) {
        return _c("div", { key: index, staticClass: "d-flex pb-1" }, [
          _vm._m(0, true),
          _vm._v(" "),
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn btn-link p-0 text-left",
                attrs: {
                  type: "button",
                  id: _vm.id + "-" + index + "-popover-engagement",
                  "data-toggle": "popover",
                  "data-trigger": "focus",
                  "data-html": true,
                  "data-content": plan_feature.description,
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(plan_feature.title) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "pr-1", staticStyle: { "font-size": "1.3em" } },
      [
        _c("i", {
          staticClass: "feather icon-check text-bold-700",
          staticStyle: { color: "green" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }